import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useRef } from "react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const process = async () => {
      const hash = location.hash;
      const sessionId = hash.split("session_id=")[1]?.split("&")[0];
      if (!sessionId) {
        navigate("/auth", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.role === "admin" ? "/admin" : "/dashboard", { replace: true, state: { user: data } });
      } catch {
        navigate("/auth", { replace: true });
      }
    };
    process();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" data-testid="auth-callback-loading">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-[#003366]" />
      <p className="text-slate-600 text-sm">Accesso in corso...</p>
    </div>
  );
}
